import en from "./en.json";
import it from "./it.json";

const banner = { en, it };

export default banner;
